/**
 * ZUSTAND STORE: Scoring Store
 *
 * RESPONSIBILITY:
 * - Hold backend-authoritative state
 *
 * MUST NEVER:
 * - Store ball input
 * - Store UI flags
 * - Compute cricket logic
 */

import { create } from "zustand";

export const useScoringStore = create(() => ({
  aggregate: null,
  battingStats: [],
  bowlingStats: [],
  actions: {},
  events: {},
  matchEnded: false,
  matchTitle: "",
  battingTeamName: "",
  bowlingTeamName: "",
  battingTeamId: null,
  bowlingTeamId: null,
  inningsId: null,
  currentInningsNumber: null,
  players: {
    batters: [],
    bowlers: []
  },
  umpires: [],
  // Off-field officials — separate from the on-field umpires list so
  // the DRS / wicket-details dropdowns can offer only the relevant
  // person (the third umpire is the TV ump, the fourth is reserve).
  thirdUmpire: null,
  fourthUmpire: null,
  matchReferee: null,
  // Server-derived Test day/session/overs-today — {current_day,
  // current_session, overs_bowled_today}. None for limited overs.
  // Set by applyServerState on every BBP API response so refreshes
  // and device swaps always show the cricket-correct values rather
  // than stale localStorage.
  testState: null,
  // 2026-06-06 (v2) — Super Over context exposed by the backend read
  // model. isSuperOver toggles SO-specific UI affordances
  // (rose banner, /2 wickets suffix, /1.0 overs suffix);
  // superOverIndex is 1 for the chasing-team SO, 2 for the response SO.
  isSuperOver: false,
  superOverIndex: null,
  // 2026-06-10 — bowling-end context. Populated from the session read
  // model. The BBP pre-1st-ball modal fires when firstOverBowlingEnd
  // is empty AND both stadium end names are non-empty. The current-end
  // chip during scoring derives from firstOverBowlingEnd + aggregate.
  // completed_overs (odd → same as first, even → opposite).
  firstOverBowlingEnd: "",     // "" | "A" | "B"
  stadiumEndAName: "",
  stadiumEndBName: "",
}));

